import React from 'react'
import { Spinner} from 'react-bootstrap'


function loader() {
  return (
    <div className="loader"
      style={{
        display: 'flex',
        justifyContent: 'center',  // centra orizzontalmente
        alignItems: 'center',      // centra verticalmente
        minHeight: '50vh',         // altezza minima, altrimenti non c'è spazio per centrare
      }}
      >
    {/* <img src='/static/images/loader3.gif' alt="Loading..." /> */}
    <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  )
}

export default loader